import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";

import CustomText from "@components/CustomText";
import MessageWrapper from "./MessageWrapper";

const OptionButton = ({ option, value, onSelect, item }) => {
  return (
    <TouchableOpacity
      onPress={onSelect}
      style={[
        styles.optionTextContainer,
        {
          backgroundColor: option.value === value ? "#F5D69D" : "white",
          width:
            item.name === "occupation" && option.key.length > 16
              ? "95%"
              : "45%",
        },
      ]}
    >
      <CustomText
        key={option.key}
        variant="body_text_4"
        style={styles.optionText}
      >
        {option.key}
      </CustomText>
    </TouchableOpacity>
  );
};

const CustomDropDownBox = ({ item, onSelect, value }) => {
  return (
    <MessageWrapper>
      <View style={styles.container}>
        <Text style={styles.questionText}>{item?.heading}</Text>
        <View style={styles.buttonContainer}>
          {item?.options?.map((option, i) => {
            return (
              <OptionButton
                key={`${item.name}${i}`}
                option={option}
                value={value}
                item={item}
                onSelect={() =>
                  onSelect(item?.isLast, { [item.name]: option?.value })
                }
              />
            );
          })}
        </View>
      </View>
    </MessageWrapper>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#ffffff",
    borderRadius: 5,
    padding: 6,
    marginHorizontal: 8,
    paddingVertical: 8,
  },
  questionText: {
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontWeight: "600",
  },
  buttonContainer: {
    margin: 12,
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  optionTextContainer: {
    backgroundColor: "white",
    margin: 6,
    padding: 10,
    borderRadius: 6,
    // minWidth: 140,
    width: "100%",
    borderColor: "#D3D3D3",
    borderWidth: 1,
  },
  optionText: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: "NotoSansDevanagari-Regular",
    fontWeight: "400",
  },
});

export default CustomDropDownBox;
